import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig} from "config/config"; // Importing development configuration

/**
 * Class representing a view for getting report structure of games.
 * @extends JetView
 */
export default class TableGetReportStructureGamesView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a number as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + "%"; // Formatting value as percentage
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            id: "datatable", // ID for the datatable
                            view: "datatable", // Webix datatable view
                            scroll: "xy", // Enable both horizontal and vertical scrolling
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                            columns: [
                                {
                                    id: "Date", // Column ID
                                    header: _("Fecha"), // Column header with localization
                                    width: 200, // Column width
                                },
                                {
                                    id: "User_id",
                                    header: _("ID Jugador"),
                                    width: 200
                                },
                                {
                                    id: "User_name",
                                    header: _("Nombre del jugador"),
                                    width: 350
                                },
                                {
                                    id: "Game_name",
                                    header: _("Nombre del Juego"),
                                    width: 350
                                },
                                {
                                    id: "TypeGame",
                                    header: _("Tipo de Juego"),
                                    width: 200
                                },
                                {
                                    id: "Bet_id",
                                    header: _("ID Apuesta"),
                                    width: 200
                                },
                                {
                                    id: "Transaction_date",
                                    header: _("Fecha de la transacción"),
                                    width: 250
                                },
                                {
                                    id: "Type_transaction",
                                    header: _("Tipo de transacción"),
                                    width: 250
                                },
                                {
                                    id: "Amount",
                                    header: _("Monto"),
                                    width: 200
                                },
                                {
                                    id: "state",
                                    header: _("Estado"),
                                    width: 250
                                },
                            ],
                            on: {
                                /**
                                 * Event handler for before loading data into the datatable.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>");
                                },
                                /**
                                 * Event handler for after loading data into the datatable.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                }
                            },
                            /**
                             * Event handler for when the datatable is ready.
                             */
                            ready: function () {
                                if (!this.count()) { // Check if there are no records
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>"); // Show no data overlay
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations on the datatable
                            datafetch: 10, // Number of records to fetch at a time
                            pager: "pagerA" // ID of the pager component
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        let url = devConfig.geturlApi() + "/RegulationReports/GetReportStructureGames"; // API endpoint for fetching report data

        this.on(this.app, "getReportStructureGames:filter", filterData => {
            let object = Object.entries(filterData); // Convert filter data to entries
            let string1 = ""; // Initialize query string

            for (let i = 0; i < object.length; i++) {
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) { // Check if value is not an object and not empty
                    if (object[i][0] == "Datepicker") { // Handle date range filter
                        let date = object[i][1].split(" - ");
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] != "Sort" && object[i][0] != "Dir" && object[i][0] != "Date") {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == "Date") { // Handle single date filter
                                let date = object[i][1].replace(" 00:00:00", "");
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) { // Handle object type filters
                        let object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (let j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) { // Check if value is not null
                                if (object2[j][0] === "start") { // Handle start date
                                    let d = new Date(object2[j][1]);
                                    let dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === "end") { // Handle end date
                                        let d = new Date(object2[j][1]);
                                        let dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            $$("consultDesk").define("disabled", true); // Disable consult desk during loading
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1).then((response) => {
                $$("consultDesk").define("disabled", false); // Re-enable consult desk after loading
            }).catch((e) => {
                $$("consultDesk").define("disabled", false); // Re-enable consult desk on error
            });
            $$("filterPopup").hide(); // Hide filter popup
        });

        $$("pagerA").attachEvent("onAfterPageChange", function (page) {
            webix.delay(function () {
                if (page != '0') {
                    chargeTable(); // Load data for the new page
                }
            }, '', '', 100);
        });

        this.on(this.app, "changeSize", filterData => {
            chargeTable(); // Reload table on size change
        });

        /**
         * Loads data into the grid based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Get the size of the pager
            let page = grid.getPage(); // Get the current page
            let first = size * page; // Calculate the starting index
            let last = (first + size) - 1; // Calculate the ending index
            grid.load(url + '?start=' + (first) + '&count=' + (last + 1) + filter); // Load data into the grid
        }
    }
}

// FILE DOCUMENTED
